import React from "react"

import FacebookShare from "./social/FacebookShare"
import LinkedInShare from "./social/LinkedInShare"
import TwitterShare from "./social/TwitterShare"

const cb = "cp-share-social"

interface SocialShareProps {
  title: string
  description: string
  uri: string
  round?: boolean
  children?: React.ReactNode
  iconFillColor?: string
  bgStyle?: object
  iconFillColorHover?: string
  bgStyleHover?: object
}

const SocialShare: React.FC<SocialShareProps> = ({ ...props }) => (
  <div className={cb}>
    <div className={`${cb}__row`}>
      <div className={`${cb}__contain`}>
        <div className="flex">
          <FacebookShare {...props} />
          <TwitterShare {...props} />
          <LinkedInShare {...props} />
        </div>
      </div>
    </div>
  </div>
)

export default SocialShare
